import axios, { AxiosInstance } from 'axios';
import ApiError from '@/api/misc/ApiError';
import { Vue } from 'vue-property-decorator';
import ProxyChecker from '@/misc/ProxyChecker';
import store from './../../store/index';

/**
 * Base repository class
 */
export default class EntityBaseRepository {

    protected axiosClient!: AxiosInstance;
    protected baseURL: string = ProxyChecker.getBaseURL() + process.env.VUE_APP_BASE_URL_EXTENSION!;

    protected endpointDefault: string = process.env.VUE_APP_ENDPOINT_DEFAULT!;
    protected endpointThumbnail: string = process.env.VUE_APP_ENDPOINT_THUMBNAIL!;
    protected endpointPage: string = process.env.VUE_APP_ENDPOINT_PAGE!;

    constructor() {
        this.createHttpClient();
        this.setRequestInterceptors();
        this.setResponseInterceptors();
    }

    private createHttpClient() {
        this.axiosClient = axios.create({
            baseURL: this.baseURL,
            withCredentials: true, // necessary to send php sessionId for client identification
            headers: {
                'Content-Type': 'application/x-www-form-urlencoded'
            }
        });
    }

    /**
     * Add Bridge values if necessary
     * @private
     */
    private setRequestInterceptors() {
        this.axiosClient.interceptors.request.use((config) => {
            // if bridge value is available - use it!
            if (store.getters['auth/bridge']) {
                config.headers = { Bridge: store.getters['auth/bridge'] };
            }
            return config;
        });
    }

    private setResponseInterceptors() {
        // -- normalize response
        this.axiosClient.interceptors.response.use(
            (response) => {
                // check for error
                // shm api returns no http error codes when a response has an error...
                // if the response has a code, an error occured
                if (response.data.response?.code) {
                    if (response.data.response.code === 110) { // means user is no session
                        // TODO handle me correctly!
                        // alert('User has no session. This event has to be handled');
                    } else {
                        throw new ApiError(response.data.response.code, response.data.response.message, response.data.response.data);
                    }
                }
                return response;
            },
            (error) => {
                if (error.response) {
                    console.log(error, error.response);
                    // has response -> server error
                    Vue.notifyErrorSimplified('GENERAL.NOTIFICATIONS.SERVER_ERROR');
                    return new Promise(() => {
                        // cancels process of the interceptor chain
                    });
                } else {
                    // no response -> network error
                    Vue.notifyErrorSimplified('GENERAL.NOTIFICATIONS.NETWORK_ERROR');
                    return new Promise(() => {
                        // cancels process of the interceptor chain
                    });
                }
            });
    }
}
